import apiClient from '../apiClient';
import { PUT_ACCOMODATION_ITEM_URL } from '../apiUrl';

const putAccomodationItemApi = data => {
  return apiClient.put(PUT_ACCOMODATION_ITEM_URL(data.ServiceItemId), data);
};

export default putAccomodationItemApi;
